module.exports = __webpack_public_path__ + "img/sweep-svgrepo-com.8351f3b0.svg";